import * as React from 'react';

import { cn } from '@/utils/helpers';
import { cva } from 'class-variance-authority';

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 whitespace-nowrap',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-primary text-primary-foreground',
        secondary: 'border-transparent bg-secondary text-secondary-foreground ',
        destructive: 'border-transparent bg-destructive text-destructive-foreground',
        outline: 'text-foreground',
        discount:
          'px-2 py-1 text-xs text-white rounded-full bg-tertiary font-secondary inline-block border-transparent',
        item_event: 'bg-[#F4F3FF] text-[#5925DC] font-medium text-sm border-transparent',
        item_course: 'bg-rose-50 text-rose-600 font-medium text-sm border-transparent',
        item_learningPath: 'bg-[#F2F4F7] text-[#344054] font-medium text-sm border-transparent',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

function Badge({ className, variant, style, itemType, ...props }) {
  // Handle item type variants
  const finalVariant = itemType
    ? itemType === 'event'
      ? 'item_event'
      : itemType === 'course'
        ? 'item_course'
        : itemType === 'learningPath'
          ? 'item_learningPath'
          : variant
    : variant;

  return <div className={cn(badgeVariants({ variant: finalVariant }), className)} style={style} {...props} />;
}

export { Badge, badgeVariants };
